import BaseApi from '~/api/base';
import mock from './mock.json';
class Notifications extends BaseApi {
    constructor() {
        super('/notification');
    }
    get(queryParams = {}) {
        if (this.useMock) {
            return mock;
        }
        return super.get(queryParams);
    }
}
const NotificationsApi = new Notifications();
export default NotificationsApi;
